//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { first, firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';
import { LibraryMasterService } from 'src/app/Services/Libraries/Library-Master/library-master.service';


//-================ IMPORTS FOR CONSTANTS ================-\\

//-================ IMPORTS FOR DEPENDENCIES ================-\\
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Response_GeneralCDMS } from 'src/app/Interfaces/GeneralCDMS/Response_GeneralCDMS.interface';
import { File_Search } from 'src/app/Interfaces/GeneralCDMS/File_Search.interface';
import { Icon_Images } from 'src/app/Interfaces/Interfaces-Global/Icon_Images.interface';
import { Icon_Image } from 'src/app/Constants/Constants-Global/Images-Icon';
import { LibraryCDMS } from 'src/app/types/General/Library.type';
import { UserDataService } from 'src/app/Services/Authentication/User/user-data.service';
import { UserDataCDMS } from 'src/app/Interfaces/GeneralCDMS/User/User.interface';
import { Response_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Response_FIN.interface';
import { library } from '@fortawesome/fontawesome-svg-core';


//-================ LOCAL INTERFACES ================-\\
interface Option_Select {
  Name: string,
  Value: number | string
}

interface O_Select_Library {
  Name: string,
  Value: number[],
  key: LibraryCDMS
}


@Component({
    selector: 'app-advance-search-cdms',
    templateUrl: './advance-search-cdms.component.html',
    styleUrls: ['./advance-search-cdms.component.scss', '../../../Styles/GlobalStyles.css'],
    standalone: false
})


export class AdvanceSearchCDMSComponent implements OnInit {

  //+================== VARIABLES FOR TYPE FILES ==================+\\
  public Option_Type_File: Option_Select[] = [
    { Name: 'Word', Value: 'docx' },
    { Name: 'Word (2003)', Value: 'doc' },
    { Name: 'Excel', Value: 'xlsx' },
    { Name: 'Excel (2003)', Value: 'xls' },
    { Name: 'P Point', Value: 'pptx' },
    { Name: 'P Point (2003)', Value: 'ppt' },
    { Name: 'Pdf', Value: 'pdf' },
    { Name: 'Img', Value: 'png' }
  ];

  //+================== VARIABLES TYPE LIBRARY ==================+\\
  public Option_Type_Library: O_Select_Library[] = []

  public Option_Type_LibraryCopy: O_Select_Library[] = [
    // { Name: 'CCP', Value: [2], key: 'CCP' },
    // { Name: 'ISO', Value: [4], key: 'ISO' },
    { Name: 'Processes', Value: [5], key: 'FIN' },
    // { Name: 'Safety & Health Processes', Value: [7], key: 'SEC' },
    // { Name: 'IT/IS Processes', Value: [8], key: 'IT' },
  ];

  //+================== VARIABLES FOR DYNAMIC LIBRARIES ==================+\\
  // Map de slug -> { ID, Nombre } para las librerías dinámicas cargadas del servidor
  private dynamicLibraryMap: Map<string, { ID: number, Nombre: string }> = new Map();

  //+================== VARIABLES FOR PLANT OR DEPARTAMENT ==================+\\
  public Option_Type_Plant: Option_Select[] = [
    { Name: 'Sin plantas', Value: 1 },
  ];


  //+================== VARIABLES OPTIONS ==================+\\
  public Select_Option_Type_File: Option_Select | null = null;
  public Select_Option_Type_Libr: O_Select_Library | null = null;


  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  public Files_Search: File_Search[] = [];

  public Input_Search: string = '';

  public IsSearch: boolean = false;
  public LoadPage: boolean = false;
  public SearchContent: boolean = false;
  public Input_Content_Search: string = '';

  public SeeCard: boolean = false;

  //+================== VARIABLES FOR ICONS IMAGE ==================+\\
  public Icons_Image: Icon_Images[] = Icon_Image;

  //+================== VARIABLES FOR REGULAR EXPRESION ==================+\\
  private Expression1: RegExp = /[/]+[0-9]+§/

  public Document_Selected: File_Search = {
    ID: 0,
    Name: '',
    Extension: '',
    Status: 0,
    Date_Created: null,
    Date_Expiration: null,
    Contributor_Name: '',
    Path: '',
    Library: 0
  };

  //-========================= SERVICES =========================-\\
  private Service_GeneralCDMS = inject(GeneralCDMSService);
  private MasterLibraryService = inject(LibraryMasterService);
  public UserService = inject(UserDataService);
  private router = inject(Router);

  async ngOnInit(): Promise<void> {
    await this.loadDynamicLibraries();
    await this.fillTemplateLibrary();
  }

  //&===================== FUNCTIONS FOR LOAD COMPONENT =====================&\\

  /**
   * Carga del servidor todas las librerías activas (incluyendo las dinámicas)
   * y las agrega al dropdown de Librería en Búsqueda Avanzada.
   */
  private async loadDynamicLibraries(): Promise<void> {
    try {
      const res: Response_FIN = await firstValueFrom(this.MasterLibraryService.Get_Active_Libraries());
      if (!res.success) return;

      const staticSlugs = ['processes', 'fin', 'ccp'];

      for (const lib of res.operation || []) {
        const slug  = String(lib?.Slug  || '').toLowerCase();
        const name  = String(lib?.Nombre || lib?.Slug || slug);
        const id    = Number(lib?.ID);

        if (!slug || staticSlugs.includes(slug)) continue;

        // Guardar en el mapa para usarlo en Library_String y SeeFINLibrary
        this.dynamicLibraryMap.set(slug, { ID: id, Nombre: name });

        // Agregar al array de opciones del dropdown usando ID como valor
        const existsOption = this.Option_Type_LibraryCopy.some(o => o.key === slug);
        if (!existsOption) {
          this.Option_Type_LibraryCopy.push({ Name: name, Value: [id], key: slug });
        }
      }
    } catch (e) {
      console.error('Error loading dynamic libraries for advanced search', e);
    }
  }

  private async fillTemplateLibrary(): Promise<void> {

    this.UserService.GetDataUser.pipe(first(value => value.ID !== 0)).subscribe((userData: UserDataCDMS) => {

      this.Option_Type_Library = []

      for (const option of this.Option_Type_LibraryCopy) {
        this.Option_Type_Library.push(option)
      }
    });
  }
  //&===================== END FUNCTIONS FOR LOAD COMPONENT =====================&\\


  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-============== FUNCTION FOR FORMAT DATE CREATED ==============-\\
  public Get_Date_Created(Date_Created: Date | null): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-============== FUNCTION FOR FORMAT DATE MODIFICATION ==============-\\
  public Get_Date_Modification(Modification: Date | null): string {
    return moment(Modification).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-============== FUNCTION FOR FORMAT DATE EXPIRATION ==============-\\
  public Get_Date_Expiration(Expiration: Date | null): string {
    return moment(Expiration).utc().format('DD/MM/YYYY hh:mm:ss a')
  }

  //-============== FUNCTION FOR FORMAT STATUS ==============-\\
  public Status_string(Status: number): string {
    switch (Status) {
      case 1: return 'Aprobado';
      case 2: return 'Pendiente';
      case 3: return 'Rechazado';
      case 4: return 'Eliminado';
      default: return '';
    }
  }

  //-================ FUNCTION FOR FORMAT LIBRARY ================-\\
  public Library_String(Library: number): string {

    switch (Library) {
      case 2: return 'CCP';
      case 4: return 'ISO';
      case 5: return 'Processes';
      case 7: return 'Safety & Health Processes';
      case 8: return 'IT/IS Processes';
      default: {
        // Buscar en librerías dinámicas por ID
        for (const [, data] of this.dynamicLibraryMap) {
          if (data.ID === Library) return data.Nombre;
        }
        return 'Librería';
      }
    }
  }

  public Library_String_Type_Library(Library: number): string {

    switch (Library) {
      case 1: return 'Archivo';
      case 2: return 'Archivo';
      case 3: return 'Archivo';
      case 4: return 'Procedimiento';
      case 5: return 'Proceso';
      case 6: return 'Proceso';
      case 7: return 'Proceso';
      case 8: return 'Proceso';
      default: return 'Documento';
    }
  }

  //-================ FUNCTION FOR ASIGN FILE TO CARD ================-\\
  public Asign_Document(Document: File_Search): void {
    this.Document_Selected = Document;
    this.Enabled_Or_Disbled_See_Card(true);
  }

  //-================ FUNCTION FOR ENABLED OR DISABLED CARD ================-\\
  public Enabled_Or_Disbled_See_Card(Condition: boolean) {
    this.SeeCard = Condition;
  }

  //-================ FUNCTION FOR CLEAN ROUTE ================-\\
  public Clean_Route(Route: string): string {

    const Route_Add: string = '/' + Route;

    const Route_Clean: string = Route_Add.split(this.Expression1).join('/');

    return Route_Clean.replace('/', '');
  }

  //-================ FUNCTION FOR SEE FIN IN LIBRARY ================-\\
  public SeeFINLibrary(): void {
    let Lib: string = '';
    const libId = this.Document_Selected.Library;
    const searchQueryParams = {
      path: this.Document_Selected.Path || '',
      openProperties: '1',
      documentId: String(this.Document_Selected.ID || 0),
      documentName: this.Document_Selected.Name || '',
      documentExtension: this.Document_Selected.Extension || ''
    };

    switch (libId) {
      case 2: Lib = 'CCP'; break;
      case 4: Lib = 'ISO'; break;
      case 5: Lib = 'FIN'; break;
      case 7: Lib = 'SEC'; break;
      case 8: Lib = 'IT'; break;
      default: {
        // Buscar slug en las librerías dinámicas por ID
        for (const [slug, data] of this.dynamicLibraryMap) {
          if (data.ID === libId) {
            const url = this.router.createUrlTree(
              ['/Dashboard/Lib', slug],
              { queryParams: searchQueryParams }
            );
            window.open(this.router.serializeUrl(url), '_blank');
            return;
          }
        }
        Lib = '';
      }
    }

    if (Lib) {
      const url = this.router.createUrlTree([`Dashboard/${Lib}/FMLibrary${Lib}`, this.Document_Selected.Path], {
        queryParams: searchQueryParams
      });
      window.open(this.router.serializeUrl(url), '_blank');
    }
  }

  public GoToLocationDirect(Document: File_Search, event: Event): void {
    event.stopPropagation();
    this.Document_Selected = Document;
    this.SeeFINLibrary();
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\




  //&===================== FUNCTIONS FOR GENERAL COMPONENT =====================&\\

  //-================ FUNCTION FOR SEARCH FILE ================-\\
  public async Search_Files(): Promise<void> {

    this.IsSearch = true;
    this.LoadPage = false;

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const Extension: string | number = this.Select_Option_Type_File?.Value || '';
      const Library: number[] = this.Select_Option_Type_Libr?.Value || this.Option_Type_Library.map((item: O_Select_Library) => item.Value[0]);

      // Determinar qué campo y modo usarán (aplicando trim)
      const isContentSearch = this.SearchContent;
      const searchTerm = isContentSearch ? this.Input_Content_Search.trim() : this.Input_Search.trim();

      const ResponseAS: Response_GeneralCDMS = await firstValueFrom(
        this.Service_GeneralCDMS.Advanced_Search_General({
          Name: searchTerm,
          Extension: Extension,
          Library: Library,
          SearchContent: isContentSearch
        })
      )

      if (ResponseAS.success) {

        Loader.classList.remove('active');
        this.Files_Search = ResponseAS.operation;

        const Toast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 1500,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'success',
          title: 'Se encontró coincidencia con ' + this.Files_Search.length + ' documentos!'
        })
        this.LoadPage = true;

      }

    } catch (e) {

      Swal.fire({
        title: 'Ocurrió un error al buscar',
        text: '¡Recargue la página, si el problema persiste notifique a supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
      Loader.classList.remove('active');
      this.LoadPage = true;
    }

  }

  //-================ FUNCTION FOR VALIDATE SEARCH (POR NOMBRE) ================-\\
  public Search_Validate(): void {
    this.SearchContent = false;
    if (this.Input_Search.length < 3) {
      Swal.fire({
        title: 'Búsqueda no válida',
        text: '¡La búsqueda es muy corta, mínimo 3 caracteres!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_Files();
    }
  }

  //-================ FUNCTION FOR VALIDATE SEARCH (POR CONTENIDO IA) ================-\\
  public Search_Validate_Content(): void {
    this.SearchContent = true;
    if (this.Input_Content_Search.length < 4) {
      Swal.fire({
        title: 'Búsqueda por contenido no válida',
        text: '¡Escribe al menos 4 caracteres para buscar en el contenido del archivo!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      });
    } else {
      this.Search_Files();
    }
  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER (NOMBRE) ================-\\
  public Search_Enter($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate() : 0;
  }

  //-================ FUNCTION FOR SEARCH WHIT KEY ENTER (CONTENIDO) ================-\\
  public Search_Enter_Content($event: KeyboardEvent): void {
    $event.code === 'Enter' ? this.Search_Validate_Content() : 0;
  }

  //&===================== END FUNCTIONS FOR GENERAL COMPONENT =====================&\\


}
